import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    Sheet,
    YStack,
} from 'smoothie';

import useConnectQuilttInstitution from '../hooks/useConnectQuilttInstitution';

interface LinkingSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

const AccountLinkingSheet = ({ isOpen, onClose }: LinkingSheetProps) => {
    const { connectInstitution } = useConnectQuilttInstitution();

    return (
        <Sheet isOpen={isOpen} onClose={onClose} showCloseButton={true}>
            <YStack
                paddingHorizontal={4}
                $sm={{ width: 400, alignSelf: 'center' }}
            >
                <H5Emphasized>
                    When you link a new account, it may take up to 20 minutes to
                    scan transactions
                </H5Emphasized>
                <BodyMediumRegular
                    paddingTop={16}
                    paddingBottom={24}
                    color="$gray1000"
                >
                    We’ll notify you of any additional bills we may find when
                    they’re ready.
                </BodyMediumRegular>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Continue linking"
                    onPress={() => {
                        onClose();
                        connectInstitution();
                    }}
                />
            </YStack>
        </Sheet>
    );
};

export default AccountLinkingSheet;
